import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi900 } from "../../styles/font.constants";

export const EmojiButton = styled.button`
	outline: none;
	border: solid 1px ${colours.greyDarker};
	border-radius: 55px;
	padding: 0.6rem 0.8rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	background: none;
`;

export const Value = styled.div`
	${satoshi900}
	color: ${colours.black};
`;
